export class UIDAboutSceneController {
    hide() {
        this.aboutSceneContainerDiv.classList.add('hidden');
    }
    show() {
        this.aboutSceneContainerDiv.classList.remove('hidden');
        this.sidebarController.deactivateAllButtons();
    }
    constructor(sidebarController){
        this.sidebarController = sidebarController;
        this.aboutSceneContainerDiv = document.getElementById('scene_discord_about_container');
    }
}
